import Vue from 'vue';
import Tabs from '../vue/Tabs.vue';
import Tab from '../vue/Tab.vue';

export default function(el) {
  if (el === null) return false;
  const v = new Vue({
    el,
    // render: h => h(Tabs),
    components: {
      Tabs,
      Tab,
    },
  });

  return v;
}
